import { render, staticRenderFns } from "./star-rate.vue?vue&type=template&id=51d61ea6&scoped=true"
import script from "./star-rate.vue?vue&type=script&lang=js"
export * from "./star-rate.vue?vue&type=script&lang=js"
import style0 from "./star-rate.vue?vue&type=style&index=0&id=51d61ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d61ea6",
  null
  
)

export default component.exports